/**
 * plugins/vuetify.js
 *
 * @see vuetify documentation: https://vuetifyjs.com/en/getting-started/installation/#manual-steps
 */

// Styles
import 'vuetify/styles'

/* To remove color pack uncomment below line and comment import 'vuetify/styles'*/
// import '@/assets/styles/main.scss'

// Vuetify
import { createVuetify } from 'vuetify'
import { fa, en } from 'vuetify/locale'
import theme from "@/plugins/vuetify-options/theme";
import icons from "@/plugins/icons";
import { VNumberInput } from 'vuetify/labs/VNumberInput'
export default createVuetify({
  /** @see Vuetify feature guides
   * @tutorial https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides */
  locale: {
    locale: 'fa',
    fallback: 'fa',
    messages: { fa, en },
    rtl: {fa: true},
  },
  components: {
    VNumberInput,
  },
  icons: icons,
  theme: theme
})
